import { dateFormatShortMonthDateYear12HourTime } from '@/helpers/formatting';

export default function formattedDate(date) {
  return dateFormatShortMonthDateYear12HourTime(new Date(date));
}

export function buildSinoaContent(userName, color, isMobile) {
  const $ = {
    b: (text) => `<span class="font-weight-bold">${text}</span>`,

    bullet: (content, large = false) => {
      let size = '';
      if (large) {
        size = isMobile ? 'text-h6' : 'text-h5';
      }
      return `<span class="${large ? 'font-weight-bold ' : ''}mr-${large ? 3 : 2} ${size}" style="color: ${color}; lineHeight: '1.2'">•</span><span>${content}</span>`;
    },

    tool: (label, desc, url, link) => $.bullet(`${$.b(label)} ${desc} <a href="${url}" target="_blank">${link}</a>`, false),
  };

  return {
    welcome1: `Hi ${userName},`,
    welcome2: "I'm Sinoa, your AI Grain Market Analyst.",
    welcome3: 'How can I help you today?',

    bulletWelcome1: $.bullet(
      `${$.b('Questions Remaining')} (above the input field) tracks the questions in your plan as you use them. You can buy more at any time so you don't run out!`,
      true,
    ),
    bulletWelcome2: $.bullet(
      `${$.b("Today's Top Questions")} are always free and don't count toward your Questions Remaining credits.`,
      true,
    ),

    psaIntro1: $.b('What Sinoa Can Do'),
    psaIntro2: `${$.b('Sinoa')} is built to explain the market, put signals in context, and turn information into strategy.`,

    psaBullet1: $.bullet(`${$.b('Understand the market:')} Get clear explanations of special reports like WASDE/USDA updates, analyst outlooks, and weather impacts.`),
    psaBullet2: $.bullet(`${$.b('Compare with context:')} Analyze different regions, delivery months, or historical trends.`),
    psaBullet3: $.bullet(`${$.b('Turn insights into action:')} Translate market moves into practical steps - like percent-to-sell or hedge ideas.`),
    psaBullet4: $.bullet(`${$.b('Save time on research:')} Summarize long reports and highlight what matters most for your farm or desk.`),

    psaToolsIntro1: $.b('For Live Market Numbers'),
    psaToolsIntro2: `${$.b('Sinoa')} focuses on interpretation and strategy, not live data. For the most current, precise figures, check these tools in your GrainFox account:`,

    psaTool1: $.tool('Live Prices & Futures:', 'The GrainFox Dashboard shows up-to-the-minute quotes:', '/dashboard/', 'Dashboard'),
    psaTool2: $.tool('Basis Map / Bid Finder:', 'Price Finder is where youll find local basis and buyer bids:', '/bids/map/', 'Price Finder'),
    psaTool3: $.tool('Smart Advisor Dashboard:', 'This is where your personalized sales targets & alerts are:', '/budgeting/ai_advisor/', 'Smart Advisor'),
    psaTool4: $.tool('Analyst Charts:', 'The Market Insights Dashboard shows verified price and basis trends for Commercial clients:', '/insights/overview/', 'Market Insights'),

    psaTip: `${$.b('Tip:')} When asking ${$.b('Sinoa')} questions, add a few details: who you are, where you're located, what crop you're interested in, and what you want to know specific to you. This will help Sinoa give you a much sharper response.`,
    psaExample: `${$.b('Example:')} I'm a canola producer in Central Alberta. Based on current sales recommendations, is it better to sell now or hold out for a better price?`,
    psaFeedback: 'If something looks off, ping us in the app—your feedback helps us make Sinoa sharper every week.',
  };
}
